// import isInView from '../utils/isInView'
// import checkScrollInView from '../utils/checkScrollInView'
import imageSizeUrl from '../utils/imageSizeUrl'
import setupCanvasBlurhash from '../utils/setupCanvasBlurhash'
import * as observer from '../utils/AwImgObserver.js'


const doLoadImage = function (imageUrl, el) {
  const img = new Image()
  img.onload = () => {
    el.style.backgroundImage = "url('" + imageUrl + "')"
  }
  img.src = imageUrl
}

export default {
  install(Vue) {
    Vue.directive('aw-img', {

      mounted: function (el, binding) {
        
        const size = binding.value?.size || 'original'
        if (binding.value?.image) {
        
          observer.registry(el, () => {
            doLoadImage(imageSizeUrl(binding.value.image, size), el)
          })

          if (binding.value.image.blurhash) {
            setTimeout(() => {
              const canvas = document.createElement('canvas')
              canvas.width = 32
              canvas.height = 32
              setupCanvasBlurhash(canvas, binding.value.image)
              canvas.toBlob(blob => {
                if (!el.style.backgroundImage) {
                  el.style.backgroundImage = "url('" + URL.createObjectURL(blob) + "')"
                }
              })
            }, 1)
          }
        } else {
          doLoadImage(binding.value.src, el)
        }
      },

      unmounted: function (el) {
          observer.unregistry(el)
      }

    })
  }
}